import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

export default function PendingVerificationPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const resend = async () => {
    setLoading(true); setError(''); setSent(false);
    try {
      await axios.post('/api/auth/resend-verification');
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-branding">
        <div className="auth-branding-inner">
          <div className="auth-logo"><img src="/wf-logo.png" alt="Wow Factor Baseball" style={{width:'192px',height:'192px',objectFit:'contain'}} /></div>
          <h1 className="auth-brand-name">WOW FACTOR</h1>
          <p className="auth-brand-sub">Baseball Training & Development</p>
          <div className="auth-brand-divider" />
          <p className="auth-brand-quote">"Elevating the game,<br />one session at a time."</p>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="auth-form-container" style={{ textAlign:'center' }}>
          <div style={{ fontSize:'3.5rem', marginBottom:'16px' }}>📧</div>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'2rem', letterSpacing:'0.05em', marginBottom:'12px' }}>CHECK YOUR EMAIL</h2>
          <p style={{ color:'var(--text-secondary)', lineHeight:'1.6', marginBottom:'8px' }}>
            Hi {user?.first_name || 'there'}! We sent a verification link to:
          </p>
          <p style={{ color:'var(--text-primary)', fontWeight:'600', fontSize:'1rem', marginBottom:'24px' }}>
            {user?.email}
          </p>
          <p style={{ color:'var(--text-muted)', fontSize:'0.875rem', lineHeight:'1.6', marginBottom:'32px' }}>
            Click the link in the email to activate your account and access your dashboard.
            Check your spam folder if you do not see it within a few minutes.
          </p>
          {sent && (
            <div style={{ background:'rgba(74,222,128,0.1)', border:'1px solid rgba(74,222,128,0.3)', borderRadius:'8px', padding:'12px 16px', color:'#4ade80', fontSize:'0.875rem', marginBottom:'16px' }}>
              ✓ Verification email resent! Check your inbox and spam/junk folder.
            </div>
          )}
          {error && (
            <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:'8px', padding:'12px 16px', color:'#f87171', fontSize:'0.875rem', marginBottom:'16px' }}>
              ⚠ {error}
            </div>
          )}
          <button className="btn btn-primary" onClick={resend} disabled={loading || sent} style={{ width:'100%', marginBottom:'12px' }}>
            {loading ? <span className="auth-spinner" /> : sent ? '✓ Email Sent' : 'Resend Verification Email'}
          </button>
          <button className="btn btn-outline" onClick={() => { logout().finally(() => navigate('/login')); }} style={{ width:'100%' }}>
            Log Out
          </button>
          <p style={{ color:'var(--text-muted)', fontSize:'0.8rem', marginTop:'20px' }}>
            The verification link expires after 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
}
